import React, {Component} from 'react';
import {ListGroupItem} from 'reactstrap';
import ManualPreview from 'manuals/components/ManualPreview';
import {connect} from 'react-redux';
import {selectManual} from 'manuals/actions/manual';

@connect(
    state => ({
        selectedManual: state.manuals.selectedManual,
        selectedCategory: state.manuals.selectedCategory,
    }),
    dispatch => {
        return {
            select: (manual) => dispatch(selectManual(manual))
        }
    }
)
export class Manual extends Component {

    render() {
        const {
            selectedManual,
            template,
            select,
            index
        } = this.props;
        const isTemplateSelected = selectedManual && template.id === selectedManual.id
        return (
            <ListGroupItem key={`template_${template.id}`}>
                {
                    isTemplateSelected &&
                    <ManualPreview/>
                }
                {
                    !isTemplateSelected &&
                    <button
                        className={'btn btn-link'}
                        onClick={() => select(template)}
                    >
                        {index}. {template.name}
                    </button>
                }
            </ListGroupItem>
        )
    }
}
